"use strict";

define('module/reinit_additional_fields',[],function () {
  return {
    init: function () {
      $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url.match(/^\/issues\/\d+\/edit\.js$/) || settings.url.match(/^.*\/issues\/new\.js$/)) {
          window.RXU.issues.hideAddtitionalFields();
        }
      });
    }
  }
});
